import { FunctionComponent } from 'react'
import Header from '../../components/Header'
import FRAME1 from '../../components/FRAME1'
import FRAME from '../../components/FRAME'
import WorldOfCryptic from '../../components/WorldOfCryptic'
import styles from './index.module.scss'

const CLSitedesktopadvisors: FunctionComponent = () => {
  return (
    <div className={styles.clSitedesktopadvisors}>
      <Header />
      <section className={styles.tEXTParent}>
        <div className={styles.tEXT}>
          <h1 className={styles.theAcademicAdvisors}>The academic advisors behind Cryptic Labs</h1>
        </div>
        <div className={styles.vector}>
          <FRAME1
            image59="/image-59@2x.png"
            drEricSMaskin="Dr. Eric S. Maskin"
            ericMaskinIsTheAdamsUnive="Eric Maskin is the Adams University Professor and Professor of Economics and Mathematics at Harvard. "
          />
          <FRAME1
            image59="/image-60@2x.png"
            drEricSMaskin="Sir Christopher Pissarides"
            ericMaskinIsTheAdamsUnive="Sir Christopher Pissarides is the Regius Professor of Economics at the London School of Economics."
            propHeight="unset"
          />
          <FRAME1
            image59="/image-56@2x.png"
            drEricSMaskin="Prof. Ueli Maurer"
            ericMaskinIsTheAdamsUnive="Ueli Maurer is professor of computer science and head of the Information Security and Cryptography Research Group."
            propHeight="36px"
          />
          <FRAME1
            image59="/image-57@2x.png"
            drEricSMaskin="Dr. Jonathan Katz"
            ericMaskinIsTheAdamsUnive="Dr. Jonathan Katz is a professor of computer science at the University of Maryland."
            propHeight="unset"
          />
          <FRAME1
            image59="/image-58@2x.png"
            drEricSMaskin="Prof. Victor Shoup"
            ericMaskinIsTheAdamsUnive="Victor Shoup is an internationally recognized expert in the field of cryptography."
            propHeight="unset"
          />
          <FRAME1
            image59="/image-54@2x.png"
            drEricSMaskin="Hilarie Orman"
            ericMaskinIsTheAdamsUnive="Hilaire Orman’s expertise centers on the design, development, analysis of software and systems."
            propHeight="unset"
          />
          <FRAME1
            image59="/image-61@2x.png"
            drEricSMaskin="Prof. Yongee Wang"
            ericMaskinIsTheAdamsUnive="Dr. Yongge Wang received his PhD degree from University of Heidelberg of Germany."
            propHeight="unset"
          />
          <FRAME1
            image59="/image-52@2x.png"
            drEricSMaskin="Prof. Lixin Gao"
            ericMaskinIsTheAdamsUnive="Dr. Lixin Gao is a professor of Electrical and Computer Engineering."
            propHeight="unset"
          />
          <FRAME1
            image59="/-2-1@2x.png"
            drEricSMaskin="Prof. William K. NG"
            ericMaskinIsTheAdamsUnive="William K. NG works in the areas of machine learning, privacy-preserving techniques."
            propHeight="unset"
          />
          <FRAME1
            image59="/image-53@2x.png"
            drEricSMaskin="Prof. Kevin Leyton-Brown"
            ericMaskinIsTheAdamsUnive="Hilaire Orman’s expertise centers on the design, development, analysis of software and systems."
            propHeight="unset"
          />
        </div>
      </section>
      <FRAME />
      <WorldOfCryptic />
    </div>
  )
}

export default CLSitedesktopadvisors
